/**
 * DonationsSanctuary 
 * www.santuariobasilicacoromoto.com
 * @author yadicksonvasquez@gmail.com
 * @updated 28/03/2020
 */

import React, { Component } from 'react';
import Header from './header';
import Footer from './footer';
import {Helmet} from "react-helmet";


export default class TourVirtualCathedralGuanare extends Component {

    constructor(props) {
        super(props);
        let language = this.props.language != null ? this.props.language : "es";
        let onLanguageChange = this.props.onLanguageChange != null ? this.props.onLanguageChange : null;
        if (sessionStorage.getItem('language') !== null) {         
            this.state = { lang: sessionStorage.getItem('language'), eventChangeLanguage: onLanguageChange };        
        }
        else {
            this.state = {lang: language, eventChangeLanguage: onLanguageChange };     
        }
        this.refreshLanguage = this.refreshLanguage.bind(this);
    }

    componentDidMount() {
        if (sessionStorage.getItem('language') !== null) {
            if(this.state.eventChangeLanguage!==null && typeof this.state.eventChangeLanguage !== "undefined") {              
                this.setState({ lang: sessionStorage.getItem('language') });         
                sessionStorage.setItem('language', sessionStorage.getItem('language'));        
                this.state.eventChangeLanguage(sessionStorage.getItem('language'));            
            }
        }        
    }

    refreshLanguage(value) {            
        if (value !== null && value !== '') {
            this.setState({ lang: value });                    
        }
    }

    render() {
        return (<div>
            <Helmet>
                <title>Tour Virtual Bas&iacute;lica Menor Catedral de Guanare</title>
                <meta name="description" content="Tour Virtual Bas&iacute;lica Menor Catedral de Guanare" />
                <meta name="keywords" content="tour virtual, 360, tour, virgen de coromoto, catedral, guanare" />
            </Helmet>
            <Header language={this.state.lang} onLanguageChange={this.state.eventChangeLanguage} sendData={this.refreshLanguage} />
          
            <div className="container">
                <div className="row">
                    <div className="col-xl-12 col-lg-12 d-sm-none d-none d-md-none d-xl-block d-lg-block" style={{'marginTop': '173px'}}>&nbsp;</div>
                    <div className="col-12 d-xl-none d-lg-none d-md-block d-sm-block d-block" style={{'marginTop': '80px'}}>&nbsp;</div>
                </div>

                <div className="row">
                    <div className="col-md-12 d-none d-sm-none d-md-none d-xl-block d-lg-block" align="center">
                        <div className="card">
                            <div className="card-header"><h3>Tour Virtual 360&deg; Bas&iacute;lica Menor Catedral de Guanare</h3>
                            </div>
                            <div className="card-body">
                                <iframe title="pannellum panorama viewer" width="900" height="600" webkitAllowFullScreen mozallowfullscreen allowFullScreen style={{"border-style":"none;"}} src="pannellum.htm?tour=json/CatedralGuanare_Cube.json"></iframe>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 d-block d-sm-block d-md-none d-xl-none d-lg-none" align="center">
                        <div className="card">
                            <div className="card-header"><h3>Tour Virtual 360&deg; Bas&iacute;lica Menor Catedral de Guanare</h3>
                            </div>
                            <div className="card-body">
                                <iframe title="pannellum panorama viewer" width="280" height="150" webkitAllowFullScreen mozallowfullscreen allowFullScreen style={{"border-style":"none;"}} src="pannellum.htm?tour=json/CatedralGuanare_Cube.json"></iframe>
                            </div>
                        </div>
                    </div>


                    
                    <div className="col-md-12 d-none d-sm-none d-md-block d-xl-none d-lg-none" align="center">
                        <div className="card">
                            <div className="card-header"><h3>Tour Virtual 360&deg; Bas&iacute;lica Menor Catedral de Guanare</h3>
                            </div>
                            <div className="card-body">
                                <iframe title="pannellum panorama viewer" width="550" height="300" webkitAllowFullScreen mozallowfullscreen allowFullScreen style={{"border-style":"none;"}} src="pannellum.htm?tour=json/CatedralGuanare_Cube.json"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
               

                <div className="row">
                    <div className="col-12">&nbsp;</div>
                </div>

                <div className="row">
                    <div className="col-12"><audio src="audio/HimnoVirgenCoromoto.mp3" controls autoplay loop>Your browser does not support the audio element </audio></div>
                </div>

                <div className="row">
                    <div className="col-12">&nbsp;</div>
                </div>

                <div className="row">
                    <div className="col-12">&nbsp;</div>
                </div>
                


            </div>
            <Footer />
        </div>);
    }

}